export var AltType;
(function (AltType) {
    AltType["LOCATION"] = "location";
})(AltType || (AltType = {}));
